<template>
  <IconLucideLayoutDashboard />
</template>
